import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Input,
    Table,
    Spinner,
    Button,
    Label,
} from "reactstrap";
import { entrepotActions } from "../../sagas/entrepotSlice";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { stockActions } from "../../sagas/stockSlice";

const MovementsPage = () => {
    const dispatch = useDispatch();

    const { t } = useTranslation();

    // Local filters
    const [entrepotId, setEntrepotId] = useState("");
    const [query, setQuery] = useState("");
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const { entrepots } = useSelector(state => state.entrepots);

    const mouvements = useSelector((state) => state.stock.stocks || []);
    const loading = useSelector((state) => state.stock.loading);

    // Load mouvements when filters change
    const searchMouvements = () => {
        dispatch(
            stockActions.getMouvements({
                entrepotId: entrepotId || null,
                dateFrom: dateFrom || null,
                dateTo: dateTo || null,
                query: query || null,
            })
        );
    };

    const entrepotOptions = entrepots?.map(entrepot => ({
        value: entrepot.id,
        label: entrepot.code + ' - ' + entrepot.libelle,
    })) ?? [];

    const entrepotOptionsWithAll = [
    { value: null, label: t('common.all', 'Tous') },
    ...entrepotOptions
  ];

    useEffect(() => {
        dispatch(entrepotActions.list());
        searchMouvements();
    }, []);

    return (
        <div className="page-content">
            <Row>
                <Col md={12}>
                    <Card>
                        <CardHeader className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">Mouvements de Stock</h4>
                            <Button color="primary" onClick={searchMouvements}>
                                Rechercher
                            </Button>
                        </CardHeader>

                        <CardBody>
                            <Row className="mb-4">
                                <Col md={3}>
                                    <Label htmlFor="entrepotId">{t('bonLivraison.entrepot')}:</Label>
                                    <Select
                                        id="entrepotId"
                                        options={entrepotOptionsWithAll}
                                        value={entrepotOptionsWithAll.find(option => option.value === entrepotId)}
                                        onChange={(selectedOption) => setEntrepotId(selectedOption.value)}
                                        placeholder={t('bonLivraison.selectEntrepot')}
                                        isSearchable
                                    />

                                </Col>

                                <Col md={3}>
                                    <Label>Date début</Label>
                                    <Input
                                        type="date"
                                        value={dateFrom}
                                        onChange={(e) => setDateFrom(e.target.value)}
                                    />
                                </Col>

                                <Col md={3}>
                                    <Label>Date fin</Label>
                                    <Input
                                        type="date"
                                        value={dateTo}
                                        onChange={(e) => setDateTo(e.target.value)}
                                    />
                                </Col>

                                <Col md={3}>
                                    <Label>Recherche</Label>
                                    <Input
                                        type="text"
                                        placeholder="Article, référence, motif…"
                                        value={query}
                                        onChange={(e) => setQuery(e.target.value)}
                                        onKeyDown={(e) => e.key === "Enter" && searchMouvements()}
                                    />
                                </Col>
                            </Row>

                            {/* TABLE */}
                            {loading ? (
                                <div className="text-center py-5">
                                    <Spinner color="primary" />
                                </div>
                            ) : (
                                <Table bordered hover responsive className="align-middle">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Date</th>
                                            <th>Article</th>
                                            <th>Type</th>
                                            <th>Qté</th>
                                            <th>Entrepôt</th>
                                            <th>Motif</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {mouvements.length === 0 ? (
                                            <tr>
                                                <td colSpan="10" className="text-center text-muted">
                                                    Aucun mouvement trouvé
                                                </td>
                                            </tr>
                                        ) : (
                                            mouvements.map((m, index) => (
                                                <tr key={m.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{m.dateMouvement?.replace("T", " ")}</td>
                                                    <td>
                                                        <strong>{m.articleNom}</strong>
                                                        <br />
                                                        <small className="text-muted">
                                                            {m.articleCode}
                                                        </small>
                                                    </td>

                                                    <td>
                                                        <span
                                                            className={`badge rounded-pill ${m.typeMouvement === "ENTREE"
                                                                ? "bg-success"
                                                                : m.typeMouvement === "SORTIE"
                                                                    ? "bg-danger"
                                                                    : "bg-warning"
                                                                }`}
                                                        >
                                                            {m.typeMouvement}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <strong>{m.quantite}</strong>
                                                    </td>
                                                    <td>
                                                        {m.typeMouvement === "SORTIE" ? m.entrepotSourceNom : m.entrepotDestinationNom || "-"}
                                                    </td>

                                                    <td>{m.motif || "-"}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </Table>
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default MovementsPage;
